import { useQuery } from 'react-query';
import { useDispatch } from 'react-redux';

import getTrialInformation from 'API/handlers/getTrialInformation';
import { mapTrialPeriodResponse } from 'app/store/utils';

import { setTrialPeriodData as setTrialPeriodDataAction } from 'app/store/trial-period.slice';
import TrialPeriodSelectPopup from './TrialPeriodSelectPopup';
import TrialPeriodFooterBanner from './TrialPeriodFooterBanner';
import { useAuthorizationContext } from '../Authorization';

const TrialPeriodContainer = () => {
  const {
    state: { userId },
  } = useAuthorizationContext();
  const dispatch = useDispatch();
  const isMobile = window.localStorage.getItem('isMobile') === '1';

  // Load information about trial period
  useQuery({
    queryKey: 'TrialPeriodState',
    queryFn: () => getTrialInformation(userId),
    enabled: Boolean(userId),
    onSuccess(response) {
      const mappedResponse = mapTrialPeriodResponse(response);

      dispatch(setTrialPeriodDataAction(mappedResponse));
    },
  });

  if (isMobile) {
    return null;
  }

  return (
    <>
      <TrialPeriodFooterBanner />
      <TrialPeriodSelectPopup />
    </>
  );
};

export default TrialPeriodContainer;
